import axios from 'axios'

const baseUrl = process.env.BACKEND_URL
console.log('teamsService > baseUrl:', baseUrl)

export function teamLogin(credentials, fingerprint) {
  return axios({
    method: 'post',
    url: `${baseUrl}/login`,
    data: {
      credentials,
      fingerprint,
    }
  })
  .then((teamLoginResponse) => (teamLoginResponse.data))
}

export async function getTeamsByGameId(gameId) {
  if (!gameId) {
    return []
  }
  const response = await axios({
    method: 'get',
    url: `${baseUrl}/games/${gameId}/teams`,
  })
  console.log(response)
  return response.data
}



// WEBPACK FOOTER //
// ./src/services/teamService.js